import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { useTheme } from "@emotion/react";
import NotificationPopup from "./NotificationPopup.js";

const SuccessPopup = ({ open, onClose, message, icon = "assets/icons/ok.svg" }) => {
  const theme = useTheme();

  useEffect(() => {
    if (isMobile && open) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [open]);

  return (
    <>
      <BrowserView>
        <NotificationPopup
          open={open}
          onClose={onClose}
          title="Notification"
          message={message}
          iconSrc={icon}
          buttonLabel="Back"
          variant={"success"}
        />
      </BrowserView>
      <MobileView>
        {open && (
          <Box
            sx={{
              position: "absolute",
              width: "90vw",
              left: "5vw",
              bottom: 15,
              borderRadius: "10px",
              backgroundColor: theme.palette.success.main,
              display: "flex",
              alignItems: "center",
              gap: 1,
              zIndex: 9999,
              px: 1,
              py: 0.5,
            }}
          >
            <img src="assets/icons/check.svg" alt="check"></img>
            <Typography color="white" fontSize={20}>
              {message}
            </Typography>
          </Box>
        )}
      </MobileView>
    </>
  );
};

export default SuccessPopup;
